///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/core/store/exportTypeGridColmnWidth"/>
import * as asyncStore from "Core/Medius.Core.Web/Scripts/Medius/lib/store/async";


const prefix = "Core:export-database-column-width",
        store = asyncStore.createLocalStore(prefix);

export = store;